import { EBroadcastTypes, Session, SessionTypesEnum } from '@/types/session.types';

const getSelectedBroadcastType = (session?: Session | null) => {
  // if session is on-demand, return ondemand
  if (session?.session_type === SessionTypesEnum.onDemand) {
    return SessionTypesEnum.onDemand;
  }
  // if session is breakout, return ondemand
  if (session?.session_type === SessionTypesEnum.breakoutRooms) {
    return SessionTypesEnum.breakoutRooms;
  }
  // else return the broadcast type
  return session?.broadcast_type || EBroadcastTypes.greenroom;
};

export default getSelectedBroadcastType;
